var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertSmallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2898 3.86118L1.81978 18.0012C1.64514 18.3036 1.55274 18.6465 1.55177 18.9957C1.55079 19.3449 1.64127 19.6883 1.8142 19.9917C1.98714 20.2951 2.2365 20.5479 2.53748 20.725C2.83847 20.9021 3.18058 20.9973 3.52978 21.0012H20.4698C20.819 20.9973 21.1611 20.9021 21.4621 20.725C21.7631 20.5479 22.0124 20.2951 22.1854 19.9917C22.3583 19.6883 22.4488 19.3449 22.4478 18.9957C22.4468 18.6465 22.3544 18.3036 22.1798 18.0012L13.7098 3.86118C13.5315 3.56729 13.2805 3.3243 12.981 3.15567C12.6814 2.98703 12.3435 2.89844 11.9998 2.89844C11.656 2.89844 11.3181 2.98703 11.0186 3.15567C10.7191 3.3243 10.468 3.56729 10.2898 3.86118V3.86118Z",
    stroke: "#D81010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V14.8",
    stroke: "#D81010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.0097",
    stroke: "#D81010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSmallIcon);
export default __webpack_public_path__ + "static/media/alert-small-icon.9a01a2f34ef5cadb42711759e78cb4c5.svg";
export { ForwardRef as ReactComponent };